<template>
  <div>
    <v-container>
      <h1>
        Users
      </h1>
      <br>
      <v-layout>
        <v-flex xs6>
          <v-form v-model="valid">
            <span>Grant admin access</span>
            <v-layout>
              <v-flex>
                <v-text-field label="Email" v-model="email" :rules="rules"></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn color="success" @click="addAdmin" :disabled="!valid">Add</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        valid: true,
        rules: [v => !!v || "Required"],
        email: ""
      };
    },
    methods: {
      addAdmin() {
        this.$confirm("Are you sure you want to grant " + this.email + " admin access?").then(res => {
          if (res) {
            this.$store.dispatch('addAdmin', {
                email: this.email
              })
              .then(result => {
                console.log(result);
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
      }
    }
  }
</script>

<style>

</style>